import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function B() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar60w');
    const IMG_SPECS_EU = ['eu', 'de', 'fr', 'it', 'es', 'kr'];
    return (
        <div className={`solar-60w-B ${css['solar-60w-B']}`}>
            <div className="left">
                <div className="left-top box">
                    <NextImage src={require('@publicLocal/solar-60w/pc/2_1.jpg')} alt={t('sec2_text1')} aria-label={t('sec2_text1')} />
                    <div className="text">
                        {t.rich('sec2_text1', {
                            big: (text: string) => <span className="big">{text}</span>,
                        })}
                    </div>
                </div>
                <div className="left-bottom">
                    <div className="left-bottom-left box">
                        <NextImage
                            src={require(`@publicLocal/solar-60w/pc/2_2${IMG_SPECS_EU.includes(locale) ? '_eu' : locale === 'uk' ? '_uk' : ''}.jpg`)}
                            alt={t('sec2_text2')}
                            aria-label={t('sec2_text2')}
                        />
                        <div className="text">{t('sec2_text2')}</div>
                    </div>
                    <div className="left-bottom-right box">
                        <NextImage
                            src={require(`@publicLocal/solar-60w/pc/2_3${IMG_SPECS_EU.includes(locale) ? '_eu' : locale === 'uk' ? '_uk' : ''}.jpg`)}
                            alt={t('sec2_text3')}
                            aria-label={t('sec2_text3')}
                        />
                        <div className="text">{t('sec2_text3')}</div>
                    </div>
                </div>
            </div>
            <div className="right">
                <div className="right-left box">
                    <NextImage src={require('@publicLocal/solar-60w/pc/2_4.jpg')} alt={t('sec2_text4')} aria-label={t('sec2_text4')} />
                    <div className="text">
                        {t.rich('sec2_text4', {
                            big: (text: string) => <span className="big">{text}</span>,
                        })}
                    </div>
                </div>
                <div className="right-right">
                    <div className="right-right-top box">
                        <NextImage src={require('@publicLocal/solar-60w/pc/2_5.jpg')} alt={t('sec2_text5')} aria-label={t('sec2_text5')} />
                        <div className="text">
                            {t.rich('sec2_text5', {
                                big: (text: string) => <span className="big">{text}</span>,
                            })}
                        </div>
                    </div>
                    <div className="right-right-bottom box">
                        <NextImage src={require('@publicLocal/solar-60w/pc/2_6.jpg')} alt={t('sec2_text6')} aria-label={t('sec2_text6')} />
                        <div className="text">
                            {t.rich('sec2_text6', {
                                big: (text: string) => <span className="big">{text}</span>,
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
